import { AxiosRequestConfig } from 'axios';

import { getExternalServiceBasePaths } from '@shared/constants';

/**
 * Determines whether a failed request targeted an external service.
 * Handles both request-construction styles used across the API layer:
 *  - a relative `url` combined with a `baseURL` (e.g. patient-app)
 *  - a fully-qualified `url` with no `baseURL` (e.g. bucharest firmware, auth/core APIs)
 */
export const isExternalServiceRequest = (config: AxiosRequestConfig | undefined): boolean => {
  if (!config) {
    return false;
  }

  const effectiveUrl = `${config.baseURL ?? ''}${config.url ?? ''}`;

  return getExternalServiceBasePaths().some((basePath) => basePath !== '' && effectiveUrl.startsWith(basePath));
};
